export default __webpack_public_path__ + "images/49e4ccadf086f863be120660d7b89341-check-green.svg";